import classnames from 'classnames'
import styles from './ScrollDisabler.module.scss'
import { useEffect, useMemo, useRef } from 'react'
import useStore from '@/store'
import { MAIN_ID } from '@/components/Layout/Layout'

export const DISABLE_SCROLL_CONTENT_ID = 'disable-scroll-content-420-69'

const ScrollDisabler = ({ className }) => {
  const $scrollableContentContainer = useRef(null)
  const $scrollableContent = useRef(null)
  const pageIsTransitioning = useStore(state => state.pageIsTransitioning)
  const loaderAnimationComplete = useStore(state => state.loaderAnimationComplete)
  const forceEnableScrollDisabler = useStore(state => state.forceEnableScrollDisabler)
  const isEnabled = useMemo(() => {
    return pageIsTransitioning || !loaderAnimationComplete || forceEnableScrollDisabler
  }, [pageIsTransitioning, loaderAnimationComplete, forceEnableScrollDisabler])

  const scrollToHalf = element => {
    if (!element) return
    const scrollHeight = element.scrollHeight
    const halfScrollDistance = scrollHeight / 2
    element.scrollTo({
      top: halfScrollDistance,
      behavior: 'instant',
    })
  }

  useEffect(() => {
    scrollToHalf($scrollableContentContainer.current)

    if (isEnabled) {
      if ($scrollableContent.current) {
        $scrollableContent.current.focus()
      }
    } else {
      const main = document.getElementById(MAIN_ID)
      if (main) {
        main.focus()
      }
    }
  }, [isEnabled])

  return (
    <div
      aria-hidden={!isEnabled}
      className={classnames(styles.ScrollDisabler, className, { [styles.isEnabled]: isEnabled })}
    >
      <div
        className={styles.inner}
        data-lenis-prevent
        ref={$scrollableContentContainer}
        id={DISABLE_SCROLL_CONTENT_ID}
      >
        <div
          className={styles.content}
          ref={$scrollableContent}
        >
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>
        </div>
      </div>
    </div>
  )
}

ScrollDisabler.displayName = 'ScrollDisabler'

export default ScrollDisabler
